const AdvanceSearch = {
  userSearch: {
    url: "/advance-search",
    method: "GET",
  },
};
export default AdvanceSearch;
